import { Link } from 'react-router-dom';

export default function BrandBanner() {
  return (
    <section className="relative bg-[#050505] overflow-hidden" dir="rtl">
      {/* Top line */}
      <div className="h-px w-full bg-gradient-to-r from-transparent via-[#E8721A]/40 to-transparent" />

      <div className="max-w-7xl mx-auto px-6 lg:px-12 py-24 lg:py-32">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">

          {/* Left: Image — cinematic */}
          <div className="relative order-2 lg:order-1">
            <div className="relative overflow-hidden h-[420px] lg:h-[500px]">
              <img
                src="https://public.readdy.ai/ai/img_res/93b861c83fe775aee8ebd56d4cdcab56.jpg"
                alt="نجاحات لتجارة العطور ومستحضرات التجميل"
                className="w-full h-full object-cover object-top"
              />
              {/* Cinematic overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-black/20" />
              <div className="absolute inset-0 bg-gradient-to-r from-black/40 via-transparent to-transparent" />

              {/* Floating badge — cinematic style */}
              <div className="absolute bottom-6 right-6 bg-black/90 border border-[#E8721A]/30 px-5 py-4 text-right">
                <div className="text-[#E8721A] text-[10px] font-bold tracking-widest uppercase mb-1">منذ أكثر من</div>
                <div className="text-white text-2xl font-black">12 عاماً</div>
                <div className="text-white/30 text-[10px] tracking-widest">من التميّز والثقة</div>
              </div>

              {/* Corner accents */}
              <div className="absolute top-4 left-4 w-8 h-8 border-t border-l border-[#E8721A]/40" />
              <div className="absolute bottom-4 right-4 w-8 h-8 border-b border-r border-[#E8721A]/40" />
            </div>
          </div>

          {/* Right: Content */}
          <div className="order-1 lg:order-2 text-right">
            {/* Label */}
            <div className="flex items-center gap-3 justify-end mb-6">
              <span className="text-[#E8721A] text-xs font-bold tracking-[0.3em] uppercase">مرحباً بك في عالمنا</span>
              <div className="w-12 h-px bg-[#E8721A]" />
              <div className="w-2 h-2 bg-[#E8721A]" />
            </div>

            {/* Brand Name */}
            <h2 className="text-4xl lg:text-6xl font-black text-white leading-tight mb-3">
              نجاحات لتجارة
            </h2>
            <h2 className="text-3xl lg:text-5xl font-black leading-tight mb-8">
              <span className="text-[#E8721A]">العطور ومستحضرات</span>
              <br />
              <span className="text-[#E8721A]">التجميل</span>
            </h2>

            {/* Divider */}
            <div className="flex items-center gap-4 justify-end mb-8">
              <div className="h-px bg-gradient-to-l from-[#E8721A]/60 to-transparent w-24" />
            </div>

            {/* Description */}
            <p className="text-white/40 text-base leading-relaxed mb-8 max-w-lg">
              نحن الوجهة الأولى لتجار العطور ومستحضرات التجميل في الخليج.
              نوفّر لك أجود المنتجات الأصيلة بأسعار الجملة مع دعم تجاري كامل
              لضمان نجاح مشروعك.
            </p>

            {/* Features list */}
            <ul className="space-y-3 mb-10">
              {[
                { icon: 'ri-check-double-line', text: 'منتجات أصلية 100% مع ضمان الجودة' },
                { icon: 'ri-check-double-line', text: 'أسعار جملة تنافسية لجميع الكميات' },
                { icon: 'ri-check-double-line', text: 'توصيل سريع لجميع دول الخليج العربي' },
                { icon: 'ri-check-double-line', text: 'دعم تجاري متواصل على مدار الساعة' },
              ].map((item) => (
                <li key={item.text} className="flex items-center gap-3 justify-end">
                  <span className="text-white/50 text-sm">{item.text}</span>
                  <div className="w-6 h-6 flex items-center justify-center border border-[#E8721A]/30 flex-shrink-0">
                    <i className={`${item.icon} text-[#E8721A] text-sm`} />
                  </div>
                </li>
              ))}
            </ul>

            {/* CTA Buttons */}
            <div className="flex flex-wrap items-center gap-4">
              <Link
                to="/products"
                className="flex items-center gap-2 bg-[#E8721A] text-white px-8 py-4 text-xs font-bold hover:bg-[#C05A0A] transition-all duration-300 cursor-pointer whitespace-nowrap tracking-widest uppercase"
                style={{ clipPath: 'polygon(0 0, calc(100% - 10px) 0, 100% 10px, 100% 100%, 10px 100%, 0 calc(100% - 10px))' }}
              >
                <span>تصفح المنتجات</span>
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-arrow-left-line" />
                </div>
              </Link>
              <a
                href="https://wa.me/971547172715"
                target="_blank"
                rel="nofollow noreferrer"
                className="flex items-center gap-2 border border-white/20 text-white/60 px-8 py-4 text-xs font-bold hover:border-[#E8721A]/60 hover:text-[#E8721A] transition-all duration-300 cursor-pointer whitespace-nowrap tracking-widest uppercase"
              >
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-whatsapp-line text-lg" />
                </div>
                <span>ابدأ شراكتك</span>
              </a>
            </div>
          </div>

        </div>
      </div>

      {/* Bottom line */}
      <div className="h-px w-full bg-gradient-to-r from-transparent via-[#E8721A]/40 to-transparent" />
    </section>
  );
}
